module.exports = __webpack_public_path__ + "img/icn_higher.eccf0464.svg";